const potentialValue = {
    "true": true,
    "false": false
}

const translate = (str) => {
    return potentialValue[str] || false
}

export {
    translate
}